import React from 'react';
import './Skeleton.css';

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-text-short"></div>
      <div className="skeleton-meta">
        <div className="skeleton-line skeleton-badge"></div>
        <div className="skeleton-line skeleton-username"></div>
      </div>
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div className="skeleton-detail">
      <div className="skeleton-line skeleton-back"></div>
      <div className="skeleton-line skeleton-title-large"></div>
      <div className="skeleton-meta">
        <div className="skeleton-line skeleton-badge"></div>
        <div className="skeleton-line skeleton-username"></div>
        <div className="skeleton-line skeleton-date"></div>
      </div>
      <div className="skeleton-content">
        <div className="skeleton-line skeleton-text"></div>
        <div className="skeleton-line skeleton-text"></div>
        <div className="skeleton-line skeleton-text"></div>
        <div className="skeleton-line skeleton-text"></div>
        <div className="skeleton-line skeleton-text-short"></div>
      </div>
      <div className="skeleton-actions">
        <div className="skeleton-line skeleton-button"></div>
        <div className="skeleton-line skeleton-button"></div>
        <div className="skeleton-line skeleton-button"></div>
      </div>
    </div>
  );
}

export function SkeletonList({ count = 6 }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
